import React from "react"
import PropTypes from "prop-types"
import { PrimeButton } from "components-design-system"
import PresetState from "components/Grid/Presets/PresetState/PresetState"
import "./Preset.scss"

const Preset = ({ isActive, type, agGridApi, onLoad, setDefaultPreset, onOpenModal, preset }) => {
  const [hoverTitle, setHoverTitle] = React.useState(false)

  const isDefault = () => {
    return preset.is_default && type === "user"
  }

  return (
    <div className={`grid-preset${isDefault() ? " grid-preset-active" : ""}`}>
      <div
        onMouseEnter={() => setHoverTitle(true)}
        onMouseLeave={() => setHoverTitle(false)}
        className="preset-title-wrap"
      >
        <div className="preset-title">
          <strong>{preset.name}</strong> {preset.is_default && " (default)"}
        </div>
        {hoverTitle && type === "user" && (
          <i
            className="fal fa-pencil-alt"
            onClick={() => onOpenModal("update-preset", preset)}
          />
        )}
      </div>
      <PresetState
        json={preset?.json}
        colGridApi={agGridApi}
      />
      <div className="preset-actions">
        {!preset.is_default && type === "user" && (
          <PrimeButton
            size="small"
            onClick={() => setDefaultPreset(preset)}
          >
            Set as default
          </PrimeButton>
        )}
        {!isActive && (
          <PrimeButton
            size="small"
            onClick={() => onLoad(preset)}
          >
            Load
          </PrimeButton>
        )}
        {type === "user" && (
          <PrimeButton
            icon={<i className="fal fa-trash-alt" />}
            size="small"
            onClick={() => onOpenModal("delete-preset", preset)}
          />
        )}
      </div>
    </div>
  )
}

Preset.propTypes = {
  type: PropTypes.oneOf(["user", "client"]),
}

export default Preset
